import React from "react";
import {
  IconButton,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { ReactComponent as EditIcon } from "../../Assets/Icons/PharmsmartIcon/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Icons/PharmsmartIcon/DeleteIcon.svg";
import { ReactComponent as updatePassword } from "../../Assets/Icons/PharmsmartIcon/updatePassword.svg";
import moment from "moment";
import "../../Sass/Common.scss";
import HtmlTooltipMain from "../../Components/Common/HtmlTooltipMain";
import TableEmptyState from "../../Components/Common/Table/TableEmptyState";
import TableLoadMore from "../../Components/Common/Table/TableLoadMore";
import TableCellLoader from "../../Components/Common/Table/TableCellLoader";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";

const useStyle = makeStyles((theme) => ({
  tableHead: {
    "&>tr": {
      "&>th": {
        borderBottom: "3px solid #dddddd",
        borderLeft: "3px solid #dddddd",
        whiteSpace: "nowrap !important",
        "&:first-child": {
          width: "18%",
        },
        "&:nth-child(2)": {
          width: "30%",
        },
        "&:nth-child(3)": {
          width: "18%",
        },
        "&:last-child": {
          width: "0% !important",
        },
      },
    },
  },
  tableBody: {
    "&>tr": {
      "&>td": {
        whiteSpace: "nowrap !important",
      },
    },
  },
  name: {
    color: "#464646 !important",
  },
  hoverAlign: {
    padding: "10px 6px !important",
  },
}));

const StaffTable = ({
  staffList,
  setTarget,
  columnSortingOrder,
  defaultColumnOrderBy,
  setColumnSortingOrder,
  setStaffRecordActionType,
  setEditStaffData,
  setAddStaff,
  setDeleteStaff,
  setStaffDeleteId,
  setDriver,
  setUpdateStaffPassword,
  tableCells,
}) => {
  const classes = useStyle();
  const showLoaderValue = Object.values(tableCells).filter((item) => {
    return item;
  });

  return (
    <>
      <TableContainer>
        <Table stickyHeader>
          <TableHead className={classes.tableHead}>
            <TableRow>
              {Object.keys(tableCells).map((headCell) => (
                <>
                  {tableCells[headCell].show && (
                    <>
                      {tableCells[headCell].sortable === true ? (
                        <TableCell
                          key={tableCells[headCell].id}
                          align="center"
                          padding={
                            tableCells[headCell].disablePadding
                              ? "none"
                              : "normal"
                          }
                        >
                          <TableSortLabel
                            sx={{
                              "&.MuiTableSortLabel-root": {
                                color: "white",
                              },
                              "& .MuiTableSortLabel-icon": {
                                color:
                                  columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                    ? "#525252 !important"
                                    : "#C5C5C5 !important",
                                "&.MuiTableSortLabel-iconDirectionDesc": {
                                  color: "#525252 !important",
                                },
                                "& .MuiTableSortLabel-iconDirectionAsc": {
                                  color:
                                    columnSortingOrder.orderBy ===
                                    tableCells[headCell].id
                                      ? "#525252 !important"
                                      : "#C5C5C5 !important",
                                },
                              },
                            }}
                            className="tableSort"
                            direction={
                              columnSortingOrder.orderBy ===
                              tableCells[headCell].id
                                ? columnSortingOrder.sortBy
                                : defaultColumnOrderBy
                            }
                            onClick={(e) => {
                              setColumnSortingOrder({
                                orderBy: tableCells[headCell].id,
                                sortBy:
                                  (columnSortingOrder.orderBy ===
                                  tableCells[headCell].id
                                    ? columnSortingOrder.sortBy
                                    : defaultColumnOrderBy) === "desc"
                                    ? "asc"
                                    : "desc",
                              });
                            }}
                          >
                            {tableCells[headCell].label}
                          </TableSortLabel>
                        </TableCell>
                      ) : (
                        <TableCell> {tableCells[headCell].label}</TableCell>
                      )}
                    </>
                  )}
                </>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {staffList?.loading ? (
              <TableCellLoader
                cells={
                  showLoaderValue.filter(({ show }) => show === true).length
                }
              />
            ) : staffList?.data?.list?.length > 0 ? (
              staffList?.data?.list?.map((item, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell className={classes.name} semiBold>
                      {item?.name}
                    </TableCell>

                    {Object.keys(tableCells).map((columnName) => {
                      return (
                        <>
                          {tableCells[columnName].show && (
                            <>
                              {columnName === "email" && (
                                <TableCell>{item?.email}</TableCell>
                              )}
                              {columnName === "dob" && (
                                <TableCell>
                                  {item?.dob
                                    ? moment(new Date(item?.dob)).format(
                                        "DD-MM-YYYY"
                                      ) || "N / A"
                                    : "N / A"}
                                </TableCell>
                              )}
                              {columnName === "role" && (
                                <TableCell>{item?.role}</TableCell>
                              )}
                            </>
                          )}
                        </>
                      );
                    })}

                    <TableCell>
                      <Box display={"flex"} fontWeight="300">
                        <HtmlTooltipMain title="Edit Staff">
                          <IconButton
                            className={classes.hoverAlign}
                            onClick={() => {
                              setStaffRecordActionType("editDetail");
                              setEditStaffData(item);
                              setAddStaff(true);
                            }}
                          >
                            <PrimaryIcon
                              color="primary"
                              height="19px"
                              icon={EditIcon}
                              cursor="pointer"
                            />
                          </IconButton>
                        </HtmlTooltipMain>
                        <HtmlTooltipMain title="Delete Staff">
                          <IconButton
                            className={classes.hoverAlign}
                            onClick={() => {
                              setDeleteStaff(true);
                              setStaffDeleteId(item?.id);
                              setDriver(item?.surgeries_count);
                            }}
                          >
                            <PrimaryIcon
                              height="19px"
                              icon={DeleteIcon}
                              cursor="pointer"
                            />
                          </IconButton>
                        </HtmlTooltipMain>
                        <HtmlTooltipMain
                          title="Update Staff Password"
                          placement={"bottom-start"}
                        >
                          <IconButton
                            className={classes.hoverAlign}
                            onClick={() => {
                              setStaffRecordActionType("editPassword");
                              setUpdateStaffPassword(item);
                              setAddStaff(true);
                            }}
                          >
                            <PrimaryIcon
                              height="19px"
                              icon={updatePassword}
                              cursor="pointer"
                            />
                          </IconButton>
                        </HtmlTooltipMain>
                      </Box>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableEmptyState />
            )}
            {staffList?.data?.list?.length !==
              staffList?.data?.filterd_record && (
              <TableLoadMore setRef={setTarget} />
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default StaffTable;
